// © 2026 Holmes Computer Consultants. All rights reserved. -- www.holmesconsultants.com
import type source from '../../SourceArt/ToyAssembly/mesh.json'
let sourceData:typeof source|undefined
export async function prepareToyAssembly():Promise<void>{sourceData??=(await import('../../SourceArt/ToyAssembly/mesh.json')).default}
export function fittedToy(radius:number):ToyPart[]|undefined{return sourceData===undefined?undefined:fitToy(sourceData,radius)}
export function toyAssemblyProfile():typeof source.reference|undefined{return sourceData?.reference}
export interface ToyPart {role:string;positions:number[];normals:number[];uvs:number[];triangles:number[]}
// Unit shell/core match the existing authoritative animation transforms. Corona is built
// at the current toy radius and anchored4mm above the board by its runtime transform.
export function fitToy(data:typeof source,radius:number):ToyPart[]{
 if(!Number.isFinite(radius)||radius<=0)throw Error('Invalid toy radius')
 const r=data.reference.radius,h=data.reference.height
 return data.parts.map(p=>{
  const out:ToyPart={role:p.role,positions:[],normals:[],uvs:[...p.uvs],triangles:[...p.triangles]}
  const core=p.role==='core'||p.role==='coreGlow'
  const scale=p.role==='shell'?[1/r,1/r,1/h]:core?[1/(r*.5),1/(r*.5),1/(h*.5)]:[radius/r,radius/r,radius/r]
  const offset=core?h*.45:p.role==='ring'?.004:0
  for(let i=0;i<p.positions.length;i+=3){
   out.positions.push(p.positions[i]!*scale[0]!,p.positions[i+1]!*scale[1]!,(p.positions[i+2]!-offset)*scale[2]!)
   const x=p.normals[i]!/scale[0]!,y=p.normals[i+1]!/scale[1]!,z=p.normals[i+2]!/scale[2]!,length=Math.hypot(x,y,z)
   out.normals.push(x/length,y/length,z/length)
  }
  return out
 })
}
